import React from 'react';
import { Translate } from 'react-redux-i18n';
import Button from '../../common/Button';
import logo from '../../../img/logo-idnot.png';
import Footer from '../../layout/Footer';

const ErrorPage = (): React.ReactElement => (
  <div className="error-page">
    <div className="header">
      <img className="logo" src={logo} alt="logo" />
      <h3>
        <Translate value="HEADER.MY_ID" />
      </h3>
      <div className="subtitle">
        <Translate value="HEADER.UNIQUE_ACCOUNT" />
      </div>
    </div>
    <div className="content">
      <Translate value="ERROR.LOGIN_ERROR_PART1" />
      <Translate value="ERROR.LOGIN_ERROR_PART2" />
      <div className="connect-button">
        <a aria-label="Se connecter" href="/">
          <Button
            type="secondary"
            i18nKey="HEADER.CONNECTION"
          />
        </a>
      </div>
    </div>
    <Footer />
  </div>
);

export default ErrorPage;
